import { render } from "./viajesSeway.vue?vue&type=template&id=3f80355c&scoped=true"
import script from "./viajesSeway.vue?vue&type=script&lang=js"
export * from "./viajesSeway.vue?vue&type=script&lang=js"

import "./viajesSeway.vue?vue&type=style&index=0&id=3f80355c&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f80355c"]])

export default __exports__